import { Color } from 'csstype'
import { useServerTime } from 'hooks/useServerTime'
import { calculateAge } from 'util/date/calculateAge'
import { CidadaoListagemSaudeMulherQueryModel } from 'view/acompanhamento/acompanhamento-condicao-saude/model/lista-tematica/model-saudeMulher'

import { AcompanhamentoCondicaoSaudeVacinasConsolidadoSection } from '../AcompanhamentoCondicaoSaudeVacinasConsolidadoSection'
import { RastreamentoAcompanhamentoIstPanel } from './RastreamentoAcompanhamentoIstPanel'
import { RastreamentoCancerColoUteroPanel } from './RastreamentoCancerColoUteroPanel'
import { RastreamentoCancerDeMamaPanel } from './RastreamentoCancerDeMamaPanel'
import { UltimaConsultaSaudeSexualReprodutivaPanel } from './UltimaConsultaSaudeSexualReprodutiva'

interface AcompanhamentoCondicaoSaudeMulherAccordionSectionProps {
  row: CidadaoListagemSaudeMulherQueryModel
  iconColor: Color
}

export function AcompanhamentoCondicaoSaudeMulherAccordionSection(
  props: Readonly<AcompanhamentoCondicaoSaudeMulherAccordionSectionProps>
) {
  const { row, iconColor } = props
  const { getServerTimeNow } = useServerTime()

  const saudeDaMulher = row.saudeMulher
  const { years: idadeCidadao } = calculateAge(row.dataNascimentoCidadao, getServerTimeNow().getTime())

  return (
    <>
      <UltimaConsultaSaudeSexualReprodutivaPanel
        data={saudeDaMulher?.ultimaConsulta}
        idadeCidadao={idadeCidadao}
        iconColor={iconColor}
      />
      <RastreamentoAcompanhamentoIstPanel
        hiv={saudeDaMulher?.hiv}
        sifilis={saudeDaMulher?.sifilis}
        hepatiteB={saudeDaMulher?.hepatiteB}
        hepatiteC={saudeDaMulher?.hepatiteC}
        iconColor={iconColor}
      />
      <RastreamentoCancerColoUteroPanel
        ultimaSolicitacao={saudeDaMulher?.ultimaSolicitacaoCancerColoUtero}
        ultimaSolicitacaoNome={saudeDaMulher?.ultimaSolicitacaoCancerColoUteroNome}
        ultimaAvaliacao={saudeDaMulher?.ultimaAvaliacaoCancerColoUtero}
        ultimaAvaliacaoNome={saudeDaMulher?.ultimaAvaliacaoCancerColoUteroNome}
        idadeCidadao={idadeCidadao}
        iconColor={iconColor}
      />
      <RastreamentoCancerDeMamaPanel
        ultimaAvaliacao={saudeDaMulher?.ultimaAvaliacaoCancerMama}
        ultimaSolicitacao={saudeDaMulher?.ultimaSolicitacaoCancerMama}
        idadeCidadao={idadeCidadao}
        iconColor={iconColor}
      />
      <AcompanhamentoCondicaoSaudeVacinasConsolidadoSection vacinas={saudeDaMulher?.vacinas} iconColor={iconColor} />
    </>
  )
}
